import { ForecastTimelineFilterProperty } from '@/coreDomainsModule/entities/filter';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { ICustomerForecastRepository } from '@/coreInfrastructureModule/interfaces/ICustomerForecastRepository';
import { GetBaseBusinessIdAdapter } from '../adapter/getBaseBusinessIdAdapter';
import { FilterFactory } from '@/coreDomainsModule/factories/filterFactory';

/**
 * 関連取引IDを取得するユースケース
 */
export class GetBaseBusinessIdUseCase {
  /**
   * 関連取引IDを取得する
   * @param repository - リポジトリ
   * @param customerForecastFilterProperty - フィルタ
   */
  public async Execute(
    repository: ICustomerForecastRepository,
    customerForecastFilterProperty: ForecastTimelineFilterProperty
  ): Promise<INetworkResult<string, Error>> {
    try {
      const result = await repository.getBaseBusinessId(
        GetBaseBusinessIdAdapter.adaptForRequest(FilterFactory.createRequiredForecastTimelineFilter(customerForecastFilterProperty))
      );

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }

      return {
        status: {
          type: 'success',
          data: result.status.data,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
